import styled from "styled-components";

export const StyledBetaLabel = styled.span`
  background: #fdecee;
  border: 1px solid #f3d0d6;
  border-radius: 4px;
  color: #cf324a;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 16px;
  padding: 0 6px;
`;

export const StyledOperationError = styled.div`
  color: #cf324a;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
`;

export const StyledClearLock = styled.div`
  align-items: center;
  background: rgba(14, 14, 44, 0.45);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
  /* Above Task Manager (9999) and Ant tooltips so the lock is the only surface. */
  z-index: 11000;
`;

export const StyledClearLockCard = styled.div`
  align-items: stretch;
  background: #f7f8f9;
  border: 1px solid #e4e6ee;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(14, 14, 44, 0.18);
  color: #4a4a68;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 440px;
  padding: 28px 32px;
  text-align: center;
  width: min(440px, calc(100vw - 32px));

  h3 {
    color: #cf324a;
    font-size: 16px;
    font-weight: 700;
    margin: 0;
  }

  p {
    font-size: 13px;
    line-height: 20px;
    margin: 4px 0 0;
  }
`;

export const StyledClearLockStep = styled.div`
  color: #4a4a68;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  margin-top: 4px;
  text-align: left;
`;

export const StyledClearLockProgress = styled.div`
  margin-top: 4px;
  width: 100%;
`;

export const StyledClearLockEta = styled.div`
  color: #676879;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
`;

export const StyledClearButton = styled.button`
  align-items: center;
  background: transparent;
  border: 1px solid #cf324a;
  border-radius: 6px;
  color: #cf324a;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  gap: 6px;
  height: 32px;
  padding: 0 12px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  svg {
    height: 16px;
    width: 16px;
  }
`;

export const StyledLinkedNote = styled.div`
  background: #fff8eb;
  border: 1px solid #f5d9a8;
  border-radius: 6px;
  color: #7a4b00;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 16px;
  padding: 8px 12px;
`;

export const StyledLogoSection = styled.div`
  display: flex;
  gap: 32px;
  width: 100%;
  align-items: flex-start;
`;

export const StyledLogoPreview = styled.div`
  min-width: 164px;
  max-width: 164px;
  height: 164px;
  background: ${props => (props.$hasImage ? "#fff" : "#22307A")};
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fcfdfe;
  font-size: 64px;
  font-weight: 500;
  overflow: hidden;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const StyledLogoInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledUploadBox = styled.div`
  border-radius: 2px;
  border: 1px dashed #d9d9d9;
  background: var(--MIST, #f7f8f9);
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.3s;
  width: 320px;

  &:hover {
    border-color: #b5b3b3;
    background: var(--MIST, #e7e9ec);
  }

  svg {
    width: 20px;
    height: 20px;
    color: #4a4a68;
  }

  span {
    color: var(--GREY, #4a4a68);
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 22.001px; /* 183.342% */
  }
`;

export const StyledFileItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  width: fit-content;

  svg {
    width: 12px;
    height: 12px;
    color: #4a4a68;
  }

  span {
    color: var(--GREY, #4a4a68);
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 200% */
  }
`;

export const StyledInstructions = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;

  p {
    color: #676879;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
  }
`;

export const StyledSectionDescriptionDiv = styled.div`
  color: #676879;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
